export default {"src":"/_next/static/media/humana.94818316.svg","height":24,"width":117};